"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Abierto = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.abierto'));
  });
});

var Ahorro = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ahorro'));
  });
});

var AhorroMovil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ahorro-movil'));
  });
});

var Ajustes = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ajustes'));
  });
});

var Alerta = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.alerta'));
  });
});

var AMC = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.a-m-c'));
  });
});

var AnadirMas = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.anadir-mas'));
  });
});

var Apagar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.apagar'));
  });
});

var ArrowLeftRight = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.arrow-left-right'));
  });
});

var AtClientes = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.at-clientes'));
  });
});

var Aura = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.aura'));
  });
});

var Auriculares = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.auriculares'));
  });
});

var Ayuda = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ayuda'));
  });
});

var AyudaPregunta = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ayuda-pregunta'));
  });
});

var BBDD = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.b-b-d-d'));
  });
});

var Blog = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.blog'));
  });
});

var Buscar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.buscar'));
  });
});

var Calendario = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.calendario'));
  });
});

var CalidadDeServicio = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.calidad-de-servicio'));
  });
});

var CallCenter = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.call-center'));
  });
});

var CalleTrece = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.calle-trece'));
  });
});

var CanalCero = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.canal-cero'));
  });
});

var Campana = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.campana'));
  });
});

var CasaSegura = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.casa-segura'));
  });
});

var Cerrar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cerrar'));
  });
});

var Chat = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.chat'));
  });
});

var Cheuron = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cheuron'));
  });
});

var CircleCheuron = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.circle-cheuron'));
  });
});

var Cine = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cine'));
  });
});

var CineIcon = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cine-icon'));
  });
});

var CineN = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cine-n'));
  });
});

var CineRock = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cine-rock'));
  });
});

var ClaveWifi = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.clave-wifi'));
  });
});

var Clic = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.clic'));
  });
});

var Cloud = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.cloud'));
  });
});

var Comedia = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.comedia'));
  });
});

var ComedyCentral = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.comedy-central'));
  });
});

var Compartir = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.compartir'));
  });
});

var Comprar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.comprar'));
  });
});

var ComprarDatos = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.comprar-datos'));
  });
});

var ComprarPlanes = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.comprar-planes'));
  });
});

var CompraSegura = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.compra-segura'));
  });
});

var ConfianzaOnline = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.confianza-online'));
  });
});

var Configuracion = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.configuracion'));
  });
});

var ConfiguracionCorreo = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.configuracion-correo'));
  });
});

var ConfiguracionRouter = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.configuracion-router'));
  });
});

var ConfigurarMovil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.configurar-movil'));
  });
});

var ConsultaCanjes = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.consulta-canjes'));
  });
});

var ConsultaDocumento = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.consulta-documento'));
  });
});

var Consumo = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.consumo'));
  });
});

var CorazonSalud = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.corazon-salud'));
  });
});

var Dark = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.dark'));
  });
});

var Datos = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.datos'));
  });
});

var Deporte = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.deporte'));
  });
});

var Deporte1 = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.deporte1'));
  });
});

var Deporte2 = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.deporte2'));
  });
});

var DeporteIcon = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.deporte-icon'));
  });
});

var Descargar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.descargar'));
  });
});

var DescargarApp = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.descargar-app'));
  });
});

var Desco = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.desco'));
  });
});

var DescoMando = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.desco-mando'));
  });
});

var DetalleLlamadas = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.detalle-llamadas'));
  });
});

var Dialogando = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.dialogando'));
  });
});

var Dinero = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.dinero'));
  });
});

var Directorio = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.directorio'));
  });
});

var Disney = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.disney'));
  });
});

var Documento = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.documento'));
  });
});

var Ecologico = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ecologico'));
  });
});

var Envio = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.envio'));
  });
});

var Error = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.error'));
  });
});

var Estrenos = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.estrenos'));
  });
});

var Euro = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.euro'));
  });
});

var EuroCirculo = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.euro-circulo'));
  });
});

var Eurosport = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.eurosport'));
  });
});

var Facebook = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.facebook'));
  });
});

var Factura = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.factura'));
  });
});

var Favorito = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.favorito'));
  });
});

var Fibra = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fibra'));
  });
});

var Fijo = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fijo'));
  });
});

var FijoInternet = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fijo-internet'));
  });
});

var Filtro = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.filtro'));
  });
});

var Formula1 = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.formula1'));
  });
});

var Foro = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.foro'));
  });
});

var Fox = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fox'));
  });
});

var FoxLife = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fox-life'));
  });
});

var FundacionTelefonica = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fundacion-telefonica'));
  });
});

var Fusion = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.fusion'));
  });
});

var Futbol = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.futbol'));
  });
});

var FutbolIcon = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.futbol-icon'));
  });
});

var Grabar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.grabar'));
  });
});

var Global = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.global'));
  });
});

var Golf = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.golf'));
  });
});

var Hgu = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.hgu'));
  });
});

var Hollywood = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.hollywood'));
  });
});

var Home = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.home'));
  });
});

var HomeDoor = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.home-door'));
  });
});

var Informacion = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.informacion'));
  });
});

var Instagram = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.instagram'));
  });
});

var Internet = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.internet'));
  });
});

var InternetMovil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.internet-movil'));
  });
});

var Juego = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.juego'));
  });
});

var Lanzamiento = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.lanzamiento'));
  });
});

var LaLiga = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.la-liga'));
  });
});

var LigaCampeones = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.liga-campeones'));
  });
});

var LineaAdicional = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.linea-adicional'));
  });
});

var Linkedin = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.linkedin'));
  });
});

var LlamadaEntrante = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.llamada-entrante'));
  });
});

var LlamadaEspera = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.llamada-espera'));
  });
});

var LlamadaSaliente = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.llamada-saliente'));
  });
});

var Mas80 = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.mas80'));
  });
});

var MeGusta = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.me-gusta'));
  });
});

var MensDictados = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.mens-dictados'));
  });
});

var MisPedidos = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.mis-pedidos'));
  });
});

var Motor = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.motor'));
  });
});

var MotorIcon = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.motor-icon'));
  });
});

var Movil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.movil'));
  });
});

var Movistar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.movistar'));
  });
});

var MovistarCar = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.movistar-car'));
  });
});

var MovistarCircular = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.movistar-circular'));
  });
});

var MovistarLikes = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.movistar-likes'));
  });
});

var MovistarPlus = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.movistar-plus'));
  });
});

var MpaUp = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.mpa-up'));
  });
});

var Multicontenido = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.multicontenido'));
  });
});

var Multipantalla = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.multipantalla'));
  });
});

var Noticias = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.noticias'));
  });
});

var NoVer = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.no-ver'));
  });
});

var Nube = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.nube'));
  });
});

var Nubico = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.nubico'));
  });
});

var Oferta = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.oferta'));
  });
});

var OfertasExclusivas = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ofertas-exclusivas'));
  });
});

var Ok = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ok'));
  });
});

var Ont = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ont'));
  });
});

var Opciones = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.opciones'));
  });
});

var PagarFacturas = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.pagar-facturas'));
  });
});

var PagoOnline = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.pago-online'));
  });
});

var Partidazo = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.partidazo'));
  });
});

var Perfil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.perfil'));
  });
});

var Play = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.play'));
  });
});

var Portatil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.portatil'));
  });
});

var PriorityUser = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.priority-user'));
  });
});

var Producto = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.producto'));
  });
});

var Qustodio = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.qustodio'));
  });
});

var RealMadrid = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.real-madrid'));
  });
});

var RechazoLlamada = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.rechazo-llamada'));
  });
});

var Reloj = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.reloj'));
  });
});

var Router = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.router'));
  });
});

var Seguridad = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.seguridad'));
  });
});

var SeguridadAbierta = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.seguridad-abierta'));
  });
});

var SeguroMovil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.seguro-movil'));
  });
});

var Series = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.series'));
  });
});

var SeriesIcon = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.series-icon'));
  });
});

var SeriesExtras = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.series-extras'));
  });
});

var SeriesMania = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.series-mania'));
  });
});

var ServicioTecnicoMovil = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.servicio-tecnico-movil'));
  });
});

var Sim = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.sim'));
  });
});

var SinConexion = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.sin-conexion'));
  });
});

var Sms = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.sms'));
  });
});

var SoporteTecnico = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.soporte-tecnico'));
  });
});

var Star = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.star'));
  });
});

var SundanceTv = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.sundance-tv'));
  });
});

var SYFY = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.s-y-f-y'));
  });
});

var TaquillaUp = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.taquilla-up'));
  });
});

var TarjetaCredito = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.tarjeta-credito'));
  });
});

var TCM = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.t-c-m'));
  });
});

var Telefonica = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.telefonica'));
  });
});

var TelefonicaFanshop = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.telefonica-fanshop'));
  });
});

var Tiendas = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.tiendas'));
  });
});

var Tokens = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.tokens'));
  });
});

var Tuenti = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.tuenti'));
  });
});

var Tv = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.tv'));
  });
});

var Twitter = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.twitter'));
  });
});

var Ubicacion = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ubicacion'));
  });
});

var UHD = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.u-h-d'));
  });
});

var U7D = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.u7-d'));
  });
});

var Usuario = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.usuario'));
  });
});

var Vamos = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.vamos'));
  });
});

var Ver = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.ver'));
  });
});

var Video = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.video'));
  });
});

var ViolenciaDeGenero = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.violencia-de-genero'));
  });
});

var WhatsappBlue = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.whatsapp-blue'));
  });
});

var WhatsappGreen = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.whatsapp-green'));
  });
});

var Xtra = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.xtra'));
  });
});

var Youtube = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@bit/gerenciatd.unifiedicons.youtube'));
  });
});

var SvgIconLibrary = {
  Youtube: Youtube,
  Xtra: Xtra,
  WhatsappGreen: WhatsappGreen,
  WhatsappBlue: WhatsappBlue,
  ViolenciaDeGenero: ViolenciaDeGenero,
  Video: Video,
  Ver: Ver,
  Vamos: Vamos,
  Usuario: Usuario,
  U7D: U7D,
  UHD: UHD,
  Ubicacion: Ubicacion,
  Twitter: Twitter,
  Tv: Tv,
  Tuenti: Tuenti,
  Tokens: Tokens,
  Tiendas: Tiendas,
  TelefonicaFanshop: TelefonicaFanshop,
  Telefonica: Telefonica,
  TCM: TCM,
  TaquillaUp: TaquillaUp,
  TarjetaCredito: TarjetaCredito,
  SYFY: SYFY,
  SundanceTv: SundanceTv,
  SoporteTecnico: SoporteTecnico,
  Star: Star,
  Sms: Sms,
  SinConexion: SinConexion,
  Sim: Sim,
  ServicioTecnicoMovil: ServicioTecnicoMovil,
  SeriesExtras: SeriesExtras,
  SeriesMania: SeriesMania,
  SeriesIcon: SeriesIcon,
  Series: Series,
  SeguroMovil: SeguroMovil,
  SeguridadAbierta: SeguridadAbierta,
  Seguridad: Seguridad,
  Router: Router,
  Reloj: Reloj,
  RechazoLlamada: RechazoLlamada,
  RealMadrid: RealMadrid,
  Qustodio: Qustodio,
  Producto: Producto,
  PriorityUser: PriorityUser,
  Portatil: Portatil,
  Play: Play,
  Perfil: Perfil,
  Partidazo: Partidazo,
  PagarFacturas: PagarFacturas,
  PagoOnline: PagoOnline,
  Ont: Ont,
  Ok: Ok,
  Opciones: Opciones,
  OfertasExclusivas: OfertasExclusivas,
  Oferta: Oferta,
  Nubico: Nubico,
  Nube: Nube,
  NoVer: NoVer,
  Noticias: Noticias,
  Multipantalla: Multipantalla,
  Multicontenido: Multicontenido,
  MpaUp: MpaUp,
  MovistarPlus: MovistarPlus,
  MovistarLikes: MovistarLikes,
  MovistarCircular: MovistarCircular,
  MovistarCar: MovistarCar,
  Movistar: Movistar,
  Movil: Movil,
  MotorIcon: MotorIcon,
  Motor: Motor,
  MisPedidos: MisPedidos,
  MensDictados: MensDictados,
  MeGusta: MeGusta,
  Mas80: Mas80,
  Linkedin: Linkedin,
  LineaAdicional: LineaAdicional,
  LigaCampeones: LigaCampeones,
  LaLiga: LaLiga,
  Lanzamiento: Lanzamiento,
  LlamadaEspera: LlamadaEspera,
  LlamadaSaliente: LlamadaSaliente,
  LlamadaEntrante: LlamadaEntrante,
  Juego: Juego,
  Instagram: Instagram,
  InternetMovil: InternetMovil,
  Internet: Internet,
  Informacion: Informacion,
  Hgu: Hgu,
  Hollywood: Hollywood,
  HomeDoor: HomeDoor,
  Home: Home,
  Golf: Golf,
  Grabar: Grabar,
  Global: Global,
  FutbolIcon: FutbolIcon,
  Futbol: Futbol,
  Fusion: Fusion,
  Formula1: Formula1,
  FoxLife: FoxLife,
  Fox: Fox,
  Foro: Foro,
  FundacionTelefonica: FundacionTelefonica,
  Filtro: Filtro,
  FijoInternet: FijoInternet,
  Fijo: Fijo,
  Fibra: Fibra,
  Favorito: Favorito,
  Factura: Factura,
  Facebook: Facebook,
  Euro: Euro,
  EuroCirculo: EuroCirculo,
  Eurosport: Eurosport,
  Estrenos: Estrenos,
  Error: Error,
  Envio: Envio,
  Ecologico: Ecologico,
  Dinero: Dinero,
  Directorio: Directorio,
  Documento: Documento,
  Disney: Disney,
  Dialogando: Dialogando,
  DetalleLlamadas: DetalleLlamadas,
  Desco: Desco,
  DescoMando: DescoMando,
  DescargarApp: DescargarApp,
  Descargar: Descargar,
  DeporteIcon: DeporteIcon,
  Deporte: Deporte,
  Deporte1: Deporte1,
  Deporte2: Deporte2,
  Datos: Datos,
  Dark: Dark,
  CorazonSalud: CorazonSalud,
  ConfiguracionCorreo: ConfiguracionCorreo,
  ConfiguracionRouter: ConfiguracionRouter,
  ConfigurarMovil: ConfigurarMovil,
  ConsultaCanjes: ConsultaCanjes,
  ConsultaDocumento: ConsultaDocumento,
  Consumo: Consumo,
  Configuracion: Configuracion,
  ConfianzaOnline: ConfianzaOnline,
  ComedyCentral: ComedyCentral,
  Comedia: Comedia,
  CompraSegura: CompraSegura,
  Compartir: Compartir,
  ComprarDatos: ComprarDatos,
  Comprar: Comprar,
  ComprarPlanes: ComprarPlanes,
  Cloud: Cloud,
  Clic: Clic,
  CineIcon: CineIcon,
  Cine: Cine,
  CineN: CineN,
  CineRock: CineRock,
  ClaveWifi: ClaveWifi,
  Cheuron: Cheuron,
  CircleCheuron: CircleCheuron,
  Chat: Chat,
  Cerrar: Cerrar,
  Campana: Campana,
  CasaSegura: CasaSegura,
  CalleTrece: CalleTrece,
  CallCenter: CallCenter,
  CanalCero: CanalCero,
  CalidadDeServicio: CalidadDeServicio,
  Calendario: Calendario,
  Buscar: Buscar,
  Blog: Blog,
  BBDD: BBDD,
  AyudaPregunta: AyudaPregunta,
  Ayuda: Ayuda,
  Auriculares: Auriculares,
  Aura: Aura,
  AtClientes: AtClientes,
  ArrowLeftRight: ArrowLeftRight,
  Apagar: Apagar,
  AnadirMas: AnadirMas,
  AMC: AMC,
  Alerta: Alerta,
  Ajustes: Ajustes,
  AhorroMovil: AhorroMovil,
  Ahorro: Ahorro,
  Abierto: Abierto
};
var _default = SvgIconLibrary;
exports["default"] = _default;

//# sourceMappingURL=SvgIconLibrary.js.map